import { useEffect, useState } from 'react';
const key = 'sports-hq-map-provider';
const valid = value => ['google', 'apple', 'ask'].includes(value);
const local = () => { try { const value = (window.SportsHQSettings || window.localStorage).getItem(key); return valid(value) ? value : 'ask'; } catch { return 'ask'; } };
async function request(method = 'GET', provider) {
    const response = await fetch('/sportsim/api/auth/maps', { method, credentials: 'same-origin', cache: 'no-store', ...(method === 'PUT' ? {headers: {'Content-Type': 'application/json'}, body: JSON.stringify({provider})} : {}) });
    if (!response.ok) throw new Error('save');
    return response.json();
}
export default function useMapPreference() {
    const [provider, setProvider] = useState('ask');
    const [authenticated, setAuthenticated] = useState(null);
    const [ready, setReady] = useState(false);
    const [busy, setBusy] = useState(false);
    const [notice, setNotice] = useState('');
    useEffect(() => {
        let active = true;
        if(window.SportsHQSettings){const sync=()=>{setProvider(local());setAuthenticated(window.SportsHQSettings.authenticated);setReady(true);};sync();window.addEventListener('sports-hq-settings-state',sync);return ()=>window.removeEventListener('sports-hq-settings-state',sync);}
        request().then(data => {
            if (!active) return;
            setAuthenticated(data.authenticated);
            setProvider(data.authenticated ? (valid(data.provider) ? data.provider : 'ask') : local());
            setReady(true);
        }).catch(() => { if (active) { setNotice('Kartvalet kunde inte hämtas. Försök igen genom att ladda om sidan.'); setReady(true); } });
        return () => { active = false; };
    }, []);
    const save = async value => {
        setBusy(true); setNotice('');
        try {
            if(window.SportsHQSettings) window.SportsHQSettings.setItem(key,value);
            else if (authenticated !== false) await request('PUT', value);
            else (window.SportsHQSettings || window.localStorage).setItem(key, value);
            setProvider(value);
            setNotice('Ditt val är sparat.');
        } catch { setNotice('Kartvalet kunde inte sparas. Försök igen.'); }
        finally { setBusy(false); }
    };
    return {provider, authenticated, ready, busy, notice, save};
}
